// import React, { useState, useEffect } from 'react';
// import { Modal, Box, IconButton, TextField } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import { fetchLinkingOrders, linkedOrder } from '../../../redux/orderSlice'; // Import actions from the slice
// import MainTable from '../../../components/Table/PaginationTable'; // Your custom MainTable component
// import { useSelector, useDispatch } from 'react-redux';
// import { LinkedOrderColumnDef } from '../columns/columnDef';


// const LinkedOrdersModal = ({ open, onClose }) => {
//     const dispatch = useDispatch();
//     const isLoading = useSelector(state => state.order.loading);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [pageNumber, setpageNumber] = useState(1); //  1-based indexing
//     const [pageSize, setPageSize] = useState(10);
//     const linkedOrderList = useSelector(state => state.order.linkingorders.data || []);
//     const orderDetails = useSelector((state) => state.order.orderDetails?.data || {});

//     const handleUnlinkOrder = (orderId) => {
//         dispatch(unlinkOrder({ orderId }));
//     };

//     const handleLinkOrder = (linkorderdata, actionType) => {
//         const getOrderId = (orderDetails) => {
//             if (Array.isArray(orderDetails) && orderDetails.length > 0) {
//                 return orderDetails[0].order_id; // Assuming the first item has the orderId
//             }

//             if (orderDetails && typeof orderDetails === 'object' && 'orderId' in orderDetails) {
//                 return orderDetails.orderId;
//             }

//             return null;
//         };
//         const newOrderId = getOrderId(orderDetails);
//         console.warn('Check newOrderID for Link:', newOrderId)
//         const linkedOdata = {
//             action: 'link',
//             linkedOrderId: linkorderdata.order_id,
//             linkedCompanyKeyId: linkorderdata.sender_company_key_id,
//         }
//         dispatch(linkedOrder({
//             linkedOrderId: newOrderId,
//             linkedOrderData: linkedOdata

//         }))
//         // console.warn("In Linked", linkorderdata, actionType, currentStep)
//         // handleNextStep();
//         onClose()
//     }
//     const LinkedOrderList = LinkedOrderColumnDef(handleLinkOrder)

//     // Function to handle search input changes
//     const handleSearchChange = (event) => {
//         setSearchTerm(event.target.value.toLowerCase());
//     };
//     // Handle page size change
//     const handlePageIndexChange = (newPageIndex) => {
//         setpageNumber(newPageIndex);
//     };


//     const handlePageSizeChange = (newSize) => {
//         setPageSize(newSize);
//         console.log("Page size changed to:", newSize);
//     };


//     useEffect(() => {
//         console.log(`Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber}`);
//         const queryParams = {
//             searchText: '',
//             fromDate: '',
//             toDate: '',
//             pageSize, // Use state value
//             pageNumber, // Use state value
//         };
//         dispatch(fetchLinkingOrders(queryParams));
//     }, [dispatch, pageSize, pageNumber]);
//     const filteredOrders = linkedOrderList && linkedOrderList[0] ? linkedOrderList[0].filter((order) => {
//         const orderNumber = order.order_number?.toLowerCase().includes(searchTerm) || false;
//         const orderDate = order.order_date?.toLowerCase().includes(searchTerm) || false;
//         // const populationMatch = order.population?.toString().includes(searchTerm) || false;
//         // const sizeMatch = order.size?.toString().includes(searchTerm) || false;

//         return orderNumber || orderDate
//         // || populationMatch || sizeMatch; // Combine all checks with OR
//     }) : [];

//     // console.log('Count ', filteredOrders, linkedOrderList[0])
//     if (isLoading) {
//         return <div>Loading...</div>; // Or any other loading indicator
//     }
//     // Adjust Box styling to your preference
//     return (
//         <Modal open={open} onClose={onClose}>
//             <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '80%', maxHeight: '90vh', bgcolor: 'background.paper', boxShadow: 24, p: 4, overflowY: 'auto' }}>
//                 <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
//                     <CloseIcon />
//                 </IconButton>
//                 <TextField
//                     fullWidth
//                     label="Search Orders"
//                     value={searchTerm}
//                     onChange={handleSearchChange}
//                     sx={{ mb: 2 }}
//                 />
//                 <MainTable
//                     columns={LinkedOrderList}
//                     data={filteredOrders}
//                     // enablePagination={false}
//                     pageNumber={pageNumber}
//                     initialPageSize={pageSize}
//                     onPageSizeChange={handlePageSizeChange}
//                     onPageIndexChange={handlePageIndexChange}
//                 />
//             </Box>
//         </Modal>
//     );
// }

// export default LinkedOrdersModal;
import React, { useState, useEffect } from 'react';
import { Modal, Box, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { fetchLinkingOrders, fetchOrderById, fetchOrders, linkedOrder, unlinkOrder } from '../../../../redux/orderSlice'; // Import actions from the slice
import MainTable from '../../../../components/Table/PaginationTable'; // Your custom MainTable component
import { useSelector, useDispatch } from 'react-redux';
import { LinkedOrderColumnDef } from '../../columns/columnDef';
import { useTranslation } from 'react-i18next';


const LinkedOrdersModal = ({ open, onClose, linkedOrderList, actionType, orderId, onLinkOrder, totalRecordsLink }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.order.loading);
    const [searchTerm, setSearchTerm] = useState('');
    const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
    const [pageSize, setPageSize] = useState(10);
    const orderDetails = useSelector((state) => state.order.orderDetails?.data || {});
    const linkedOrderNum = orderDetails.linkedOrderNumber || null

    const handleUnLinkOrder = (orderId, actionType) => {
        console.log('Check unlinked data:', actionType, orderId,orderDetails.orderId )
        const unLinkorderId = orderDetails.orderId 
        const linkedOdata = {
            action: actionType,

        }
        dispatch(unlinkOrder({ unLinkorderId, linkedOdata })).then(() => {
            dispatch(fetchOrderById(orderDetails.orderId || orderId));
            dispatch(fetchOrders({
                type: 'outgoing',
                searchText: '',
                fromDate: '',
                toDate: '',
                pageSize, // Use state value
                pageNumber
              }))
        })
        onClose()
    };

    const handleLinkOrder = (linkorderdata, actionType) => {
        console.log('Handle Link Order', linkorderdata, "Order Details :", orderDetails, onLinkOrder, "From Landing :", orderId)

        console.log('Check newOrderID for Link:', orderDetails.orderId)
        const linkedOdata = {
            action: actionType,
            linkedOrderId: linkorderdata.order_id,
            linkedCompanyKeyId: linkorderdata.sender_company_key_id,
        }
        dispatch(linkedOrder({
            linkedOrderId: orderDetails.orderId || orderId,
            linkedOrderData: linkedOdata

        })).then(() => {
            dispatch(fetchOrderById(orderDetails.orderId || orderId));
            dispatch(fetchOrders({
                type: 'outgoing',
                searchText: '',
                fromDate: '',
                toDate: '',
                pageSize, // Use state value
                pageNumber
              }))
        })
        onClose()
    }
    const LinkedOrderList = LinkedOrderColumnDef(handleLinkOrder, handleUnLinkOrder, linkedOrderNum, t)
    // Function to handle search input changes
    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value.toLowerCase());
    };
    // Handle page size change
    const handlePageIndexChange = (newPageIndex) => {
        setPageNumber(newPageIndex);
    };


    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        console.log("Page size changed to:", newSize);
    };

    // useEffect(() => {
    //     dispatch(fetchOrderById(orderDetails.orderId));
    //     // Cleanup function to reset order state when component unmounts

    // }, [dispatch, orderDetails.orderId]);

    // useEffect(() => {
    //     console.log(`Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber}`);
    //     const queryParams = {
    //         searchText: '',
    //         fromDate: '',
    //         toDate: '',
    //         pageSize, // Use state value
    //         pageNumber, // Use state value
    //     };
    //     dispatch(fetchLinkingOrders(queryParams));
    // }, [dispatch, pageSize, pageNumber]);

    const filteredOrders = linkedOrderList && linkedOrderList ? linkedOrderList.filter((order) => {
        const orderNumber = order.order_number?.toLowerCase().includes(searchTerm) || false;
        const orderDate = order.order_date?.toLowerCase().includes(searchTerm) || false;
        // const populationMatch = order.population?.toString().includes(searchTerm) || false;
        // const sizeMatch = order.size?.toString().includes(searchTerm) || false;

        return orderNumber || orderDate
        // || populationMatch || sizeMatch; // Combine all checks with OR
    }) : [];

    // console.log('Count ', filteredOrders, linkedOrderList[0])
    // if (isLoading) {
    //     return <div>Loading...</div>; // Or any other loading indicator
    // }
    // Adjust Box styling to your preference
    // console.log('`>>> Linked <<<<<`', linkedOrderList, actionType, orderId,orderDetails);

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '80%', maxHeight: '90vh', bgcolor: 'background.paper', boxShadow: 24, p: 4, overflowY: 'auto' }}>
                <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
                <TextField
                    fullWidth
                    label="Search Orders"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    sx={{ mb: 2 }}
                />
                <MainTable
                    columns={LinkedOrderList}
                    data={filteredOrders}
                    // enablePagination={false}
                    initialPageSize={pageSize}
                    pageNumber={pageNumber}
                    onPageIndexChange={handlePageIndexChange}
                    onPageSizeChange={handlePageSizeChange}
                    enablePagination={true}
                    totalRecords={totalRecordsLink} // Pass the totalRecords to MainTable
                    // className="custom-table-class"
                    recordCountText="records found"
                />
            </Box>
        </Modal>
    );
}

export default LinkedOrdersModal;
